export function getCurrencySymbol(currencyCode?: string) {
  const nf = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
  })

  return nf.formatToParts(1).find((x) => x.type === 'currency')?.value
}
